import Modal from 'admin/shared-components/Modal/Modal';
import { OrganizationSetting } from 'admin/types';
import { actions, useAppDispatch } from 'redux-stores';

type Props = {
  isOpen: boolean;
  options: {
    updatedSetting: OrganizationSetting;
    bodyText: string;
    headerText: string;
  };
};

export default function OrgSettingEnabledModal({ isOpen, options }: Props) {
  const { bodyText = '', headerText = '', updatedSetting } = options;
  const dispatch = useAppDispatch();

  function handleSubmit() {
    dispatch(actions.updateSettings(updatedSetting));
    dispatch(actions.setModal());
  }

  function handleClose() {
    dispatch(actions.setModal());
  }

  return (
    <Modal
      isOpen={isOpen}
      closeButton="Cancel"
      onSuccess={handleSubmit}
      onClose={handleClose}
      canClose
      header={headerText}
      doneButton="I Understand"
      isWarningButtonPresent={true}
      modalSize="small"
      body={bodyText}
    />
  );
}
